import api from '../api/api'
import { call, put, take, select } from 'redux-saga/effects'
import ordersSchema from '../schemas/orders'
import { normalize } from 'normalizr'
import { isResponseSuccessful, statusCodeIsBelow400 } from '../helpers/utility'
import { noop } from 'redux-saga/utils'

import {
  APPLY_PROMO_CODE_REQUEST,
  APPLY_PROMO_CODE_SUCCESS,
  APPLY_PROMO_CODE_FAIL,
  APPLY_PROMO_CODE_ASYNC_START,
  APPLY_PROMO_CODE_ASYNC_END,
  PAY_ORDER_REQUEST,
  PAY_ORDER_ASYNC_START,
  PAY_ORDER_ASYNC_END,
  PAY_ORDER_FAIL,
  PAY_ORDER_SUCCESS,
} from '../actions/actions'

import {
  FETCH_BUY_ORDERS_REQUEST,
  FETCH_BUY_ORDERS_SUCCESS,
  FETCH_BUY_ORDERS_FAIL,
  FETCH_BUY_ORDERS_ASYNC_START,
  FETCH_BUY_ORDERS_ASYNC_END,
} from '../actions/actions'

import {
  PAY_PENDING_ORDER_REQUEST,
  PAY_PENDING_ORDER_SUCCESS,
  PAY_PENDING_ORDER_FAIL,
  PAY_PENDING_ORDER_ASYNC_START,
  PAY_PENDING_ORDER_ASYNC_END,
} from '../actions/actions'

import {
  CANCEL_PENDING_ORDER_REQUEST,
  CANCEL_PENDING_ORDER_SUCCESS,
  CANCEL_PENDING_ORDER_FAIL,
  CANCEL_PENDING_ORDER_ASYNC_START,
  CANCEL_PENDING_ORDER_ASYNC_END,
} from '../actions/actions'

import {
  CREATE_ORDER_FOR_SERVICE_REQUEST,
  CREATE_ORDER_FOR_SERVICE_SUCCESS,
  CREATE_ORDER_FOR_SERVICE_FAIL,
  CREATE_ORDER_FOR_SERVICE_ASYNC_START,
  CREATE_ORDER_FOR_SERVICE_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_SINGLE_ORDER_REQUEST,
  FETCH_SINGLE_ORDER_SUCCESS,
  FETCH_SINGLE_ORDER_FAIL,
  FETCH_SINGLE_ORDER_ASYNC_START,
  FETCH_SINGLE_ORDER_ASYNC_END,
} from '../actions/actions'

import {
  UPDATE_ORDER_REQUEST,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAIL,
  UPDATE_ORDER_ASYNC_START,
  UPDATE_ORDER_ASYNC_END,
} from '../actions/actions'

export function* createOrderForService() {
  while (true) {
    const { formData, resolve = noop, reject = noop } = yield take(
      CREATE_ORDER_FOR_SERVICE_REQUEST
    )

    yield put({ type: CREATE_ORDER_FOR_SERVICE_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.createOrderForService, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: CREATE_ORDER_FOR_SERVICE_SUCCESS,
          order: data.order,
        })
        resolve(data.order)
      } else {
        yield put({ type: CREATE_ORDER_FOR_SERVICE_FAIL, errors })
        reject(errors)
      }
    } catch (error) {
      yield put({ type: CREATE_ORDER_FOR_SERVICE_FAIL, error })
    } finally {
      yield put({ type: CREATE_ORDER_FOR_SERVICE_ASYNC_END })
    }
  }
}

export function* updateOrder() {
  while (true) {
    const { orderId, formData, resolve = noop, reject = noop } = yield take(
      UPDATE_ORDER_REQUEST
    )

    yield put({ type: UPDATE_ORDER_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.updateOrder, orderId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: UPDATE_ORDER_SUCCESS,
          order: data.order,
        })
        resolve(data.order)
      } else {
        yield put({ type: UPDATE_ORDER_FAIL, errors })
        reject(errors)
      }
    } catch (error) {
      yield put({ type: UPDATE_ORDER_FAIL, error })
    } finally {
      yield put({ type: UPDATE_ORDER_ASYNC_END })
    }
  }
}

export function* fetchSingleOrder() {
  while (true) {
    const { orderId, resolve = noop, reject = noop } = yield take(
      FETCH_SINGLE_ORDER_REQUEST
    )

    yield put({ type: FETCH_SINGLE_ORDER_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.fetchSingleOrder, orderId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SINGLE_ORDER_SUCCESS,
          order: data.order,
        })

        resolve(data.order)
      } else {
        yield put({ type: FETCH_SINGLE_ORDER_FAIL, errors })
        reject(errors)
      }
    } catch (error) {
      yield put({ type: FETCH_SINGLE_ORDER_FAIL, error })
    } finally {
      yield put({ type: FETCH_SINGLE_ORDER_ASYNC_END })
    }
  }
}

export function* fetchBuyOrders() {
  while (true) {
    yield take(FETCH_BUY_ORDERS_REQUEST)
    yield put({ type: FETCH_BUY_ORDERS_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.fetchBuyOrders)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_BUY_ORDERS_SUCCESS,
          orders: normalize(data.orders, ordersSchema),
        })
      } else {
        yield put({ type: FETCH_BUY_ORDERS_FAIL, errors })
      }

      yield put({ type: FETCH_BUY_ORDERS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_BUY_ORDERS_ASYNC_END })
      yield put({ type: FETCH_BUY_ORDERS_FAIL, error })
    }
  }
}

export function* applyDiscountCode() {
  while (true) {
    const { formData, resolve, reject, serviceType } = yield take(
      APPLY_PROMO_CODE_REQUEST
    )

    yield put({ type: APPLY_PROMO_CODE_ASYNC_START })
    const userType = yield select(state => state.auth.userType)

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.applyDiscount, formData, userType, serviceType)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        yield put({
          type: APPLY_PROMO_CODE_SUCCESS,
          data,
        })

        resolve(data.order)
      } else {
        yield put({ type: APPLY_PROMO_CODE_FAIL, errors })
        reject(errors)
      }

      yield put({ type: APPLY_PROMO_CODE_ASYNC_END })
    } catch (error) {
      reject({ general_errors: ['اشکالی در هنگام انجام درخواست رخ داد'] })
      yield put({ type: APPLY_PROMO_CODE_ASYNC_END })
      yield put({ type: APPLY_PROMO_CODE_FAIL, error })
    }
  }
}

export function* payPendingOrder() {
  while (true) {
    const { orderId, resolve, reject } = yield take(PAY_PENDING_ORDER_REQUEST)
    yield put({ type: PAY_PENDING_ORDER_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.payPendingOrder, orderId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: PAY_PENDING_ORDER_SUCCESS,
        })

        resolve(data)
      } else {
        yield put({ type: PAY_PENDING_ORDER_FAIL, errors })
        reject(errors)
      }

      yield put({ type: PAY_PENDING_ORDER_ASYNC_END })
    } catch (error) {
      yield put({ type: PAY_PENDING_ORDER_ASYNC_END })
      yield put({ type: PAY_PENDING_ORDER_FAIL, error })
    }
  }
}

export function* payOrder() {
  while (true) {
    const { formData, resolve = noop, reject = noop } = yield take(PAY_ORDER_REQUEST)
    yield put({ type: PAY_ORDER_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.payOrder, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: PAY_ORDER_SUCCESS,
          payload: data,
        })

        resolve(data)
      } else {
        yield put({ type: PAY_ORDER_FAIL, errors })
        reject(errors)
      }
    } catch (error) {
      yield put({ type: PAY_ORDER_FAIL, error })
    } finally {
      yield put({ type: PAY_ORDER_ASYNC_END })
    }
  }
}

export function* cancelPendingOrder() {
  while (true) {
    const { orderId, resolve, reject } = yield take(CANCEL_PENDING_ORDER_REQUEST)
    yield put({ type: CANCEL_PENDING_ORDER_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.cancelPendingOrder, orderId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: CANCEL_PENDING_ORDER_SUCCESS,
        })

        resolve && resolve(data)
      } else {
        yield put({ type: CANCEL_PENDING_ORDER_FAIL, errors })
        reject && reject(errors)
      }

      yield put({ type: CANCEL_PENDING_ORDER_ASYNC_END })
    } catch (error) {
      yield put({ type: CANCEL_PENDING_ORDER_ASYNC_END })
      yield put({ type: CANCEL_PENDING_ORDER_FAIL, error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/ordersSaga.js